import { __extends } from "tslib";
import { GetBucketAccelerateConfigurationOutput, GetBucketAccelerateConfigurationRequest } from "../models/index";
import { deserializeAws_restXmlGetBucketAccelerateConfigurationCommand, serializeAws_restXmlGetBucketAccelerateConfigurationCommand, } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetBucketAccelerateConfigurationCommand = /** @class */ (function (_super) {
    __extends(GetBucketAccelerateConfigurationCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetBucketAccelerateConfigurationCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetBucketAccelerateConfigurationCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: GetBucketAccelerateConfigurationRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetBucketAccelerateConfigurationOutput.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetBucketAccelerateConfigurationCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlGetBucketAccelerateConfigurationCommand(input, context);
    };
    GetBucketAccelerateConfigurationCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlGetBucketAccelerateConfigurationCommand(output, context);
    };
    return GetBucketAccelerateConfigurationCommand;
}($Command));
export { GetBucketAccelerateConfigurationCommand };
//# sourceMappingURL=GetBucketAccelerateConfigurationCommand.js.map